module.exports = __webpack_public_path__ + "static/img/bj.37b4a8a8.png";